var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 33,
    viewBox: "0 0 57 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1283_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6166 10.1473H47.944C48.6514 10.1473 49.2365 9.5826 49.2365 8.88102C49.2365 8.17943 48.6601 7.61475 47.944 7.61475H46.6166C45.9092 7.61475 45.3241 8.17943 45.3241 8.88102C45.3241 9.5826 45.9005 10.1473 46.6166 10.1473Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5428 7.61475H36.8967C36.1894 7.61475 35.6042 8.17943 35.6042 8.88102C35.6042 9.5826 36.1806 10.1473 36.8967 10.1473H39.5428C40.2502 10.1473 40.8353 9.5826 40.8353 8.88102C40.8353 8.17943 40.2589 7.61475 39.5428 7.61475Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8231 7.61475H27.177C26.4696 7.61475 25.8845 8.17943 25.8845 8.88102C25.8845 9.5826 26.4609 10.1473 27.177 10.1473H29.8231C30.5305 10.1473 31.1156 9.5826 31.1156 8.88102C31.1156 8.17943 30.5392 7.61475 29.8231 7.61475Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 7.61475C16.7498 7.61475 16.1647 8.17943 16.1647 8.88102C16.1647 9.5826 16.741 10.1473 17.4571 10.1473H20.1032C20.8106 10.1473 21.3957 9.5826 21.3957 8.88102C21.3957 8.17943 20.8193 7.61475 20.1032 7.61475H17.4571Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3922 10.1473C11.0996 10.1473 11.6847 9.5826 11.6847 8.88102C11.6847 8.17943 11.1083 7.61475 10.3922 7.61475H9.06482C8.35745 7.61475 7.77234 8.17943 7.77234 8.88102C7.77234 9.5826 8.34871 10.1473 9.06482 10.1473H10.3922Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6166 17.762H47.944C48.6514 17.762 49.2365 17.1973 49.2365 16.4958C49.2365 15.7942 48.6601 15.2295 47.944 15.2295H46.6166C45.9092 15.2295 45.3241 15.7942 45.3241 16.4958C45.3241 17.1973 45.9005 17.762 46.6166 17.762Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5428 15.2378H36.8967C36.1894 15.2378 35.6042 15.8025 35.6042 16.5041C35.6042 17.2056 36.1806 17.7703 36.8967 17.7703H39.5428C40.2502 17.7703 40.8353 17.2056 40.8353 16.5041C40.8353 15.8025 40.2589 15.2378 39.5428 15.2378Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8231 15.2378H27.177C26.4696 15.2378 25.8845 15.8025 25.8845 16.5041C25.8845 17.2056 26.4609 17.7703 27.177 17.7703H29.8231C30.5305 17.7703 31.1156 17.2056 31.1156 16.5041C31.1156 15.8025 30.5392 15.2378 29.8231 15.2378Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4571 15.2378C16.7498 15.2378 16.1647 15.8025 16.1647 16.5041C16.1647 17.2056 16.741 17.7703 17.4571 17.7703H20.1032C20.8106 17.7703 21.3957 17.2056 21.3957 16.5041C21.3957 15.8025 20.8193 15.2378 20.1032 15.2378H17.4571Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3922 17.762C11.0996 17.762 11.6847 17.1973 11.6847 16.4958C11.6847 15.7942 11.1083 15.2295 10.3922 15.2295H9.06482C8.35745 15.2295 7.77234 15.7942 7.77234 16.4958C7.77234 17.1973 8.34871 17.762 9.06482 17.762H10.3922Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0035 22.8525H9.05603C8.34866 22.8525 7.76355 23.4172 7.76355 24.1188C7.76355 24.8204 8.33992 25.3851 9.05603 25.3851H11.0035C11.7108 25.3851 12.296 24.8204 12.296 24.1188C12.296 23.4172 11.7196 22.8525 11.0035 22.8525Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8065 22.8525C17.0991 22.8525 16.514 23.4172 16.514 24.1188C16.514 24.8204 17.0904 25.3851 17.8065 25.3851H39.1848C39.8922 25.3851 40.4773 24.8204 40.4773 24.1188C40.4773 23.4172 39.9009 22.8525 39.1848 22.8525H17.8065Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9965 22.8525C45.2891 22.8525 44.704 23.4172 44.704 24.1188C44.704 24.8204 45.2804 25.3851 45.9965 25.3851H47.9439C48.6513 25.3851 49.2364 24.8204 49.2364 24.1188C49.2364 23.4172 48.66 22.8525 47.9439 22.8525H45.9965Z",
    fill: "#54565B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8826 0H7.11736C3.19626 0 0 3.13145 0 6.97304V26.0184C0 29.8686 3.19626 32.9914 7.11736 32.9914H49.8826C53.8125 32.9914 57 29.86 57 26.0184V6.97304C57 3.12289 53.8037 0 49.8826 0ZM54.4238 26.0184C54.4238 28.4739 52.389 30.4675 49.8826 30.4675H7.11736C4.611 30.4675 2.57622 28.4739 2.57622 26.0184V6.97304C2.57622 4.5175 4.611 2.52398 7.11736 2.52398H49.8826C52.389 2.52398 54.4238 4.5175 54.4238 6.97304V26.0184Z",
    fill: "#54565B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283_1104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/keyboard-icon.4d929533344d24e3e5900c18149c11a5.svg";
export { ForwardRef as ReactComponent };